'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _Queries2 = require('./Queries');

var _Queries3 = _interopRequireDefault(_Queries2);

var WriteQueries = (function (_Queries) {
    function WriteQueries() {
        _classCallCheck(this, WriteQueries);

        if (_Queries != null) {
            _Queries.apply(this, arguments);
        }
    }

    _inherits(WriteQueries, _Queries);

    _createClass(WriteQueries, [{
        key: 'createOne',

        /**
         * Create a new entity
         * Post the data to the API to create the new object
         *
         * @param {View}   view      the formView related to the entity
         * @param {Object} rawEntity the entity's object
         *
         * @returns {promise}  the new object
         */
        value: function createOne(view, rawEntity) {
            return this._restWrapper.createOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(), view.type), view.entity.createMethod());
        }
    }, {
        key: 'updateOne',

        /**
         * Update an entity
         * Put the data to the API to create the new object
         *
         * @param {View}   view             the formView related to the entity
         * @param {Object} rawEntity        the entity's object
         * @param {String} originEntityId   if entity identifier is modified
         *
         * @returns {promise} the updated object
         */
        value: function updateOne(view, rawEntity, originEntityId) {
            var entityId = originEntityId || rawEntity[view.entity.identifier().name()];

            // Update element data
            return this._restWrapper.updateOne(rawEntity, view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.updateMethod());
        }
    }, {
        key: 'deleteOne',

        /**
         * Delete an entity
         * Delete the data to the API
         *
         * @param {String} view     the formView related to the entity
         * @param {*}      entityId the entity's id
         *
         * @returns {promise}
         */
        value: function deleteOne(view, entityId) {
            return this._restWrapper.deleteOne(view.entity.name(), this._application.getRouteFor(view.entity, view.getUrl(entityId), view.type, entityId, view.identifier()), view.entity.deleteMethod());
        }
    }, {
        key: 'batchDelete',

        /**
         * Delete a batch of entity
         * Delete the data to the API
         *
         * @param {String} view     the formView related to the entity
         * @param {*}      entityIds the entities ids
         *
         * @returns {promise}
         */
        value: function batchDelete(view, entityIds) {
            var deleteOne = this.deleteOne.bind(this);
            var promises = entityIds.map(function (id) {
                return deleteOne(view, id);
            });

            return this._promisesResolver.allEvenFailed(promises);
        }
    }]);

    return WriteQueries;
})(_Queries3['default']);

exports['default'] = WriteQueries;
module.exports = exports['default'];
//# sourceMappingURL=WriteQueries.js.map


//////////////////
// WEBPACK FOOTER
// ./~/admin-config/lib/Queries/WriteQueries.js
// module id = 43
// module chunks = 0